import { DateTime } from "luxon"
import { IOption } from "../../../components/selects/select"
import { IDashboardBusinessControlsViewDTO } from "../../../libs/coreapi-dto/accounting/dashboardBusinessControl"

export interface IDisplayItem extends IDocumentItemCostInfoViewDTO {
    readonly contractorName?: string
    readonly goodsName: string
    readonly idGlobal: string
    readonly quantityRem: number
    readonly retailPriceIncVat: number
    readonly supplierPriceIncVat: number

}

export enum typeReport {
    Illiquid = "Illiquid",
    Expired = "Expired",
    ExcessStock = "ExcessStock",
    ActualPrice = "ActualPrice",
    SalesReport = "SalesReport",
    WithoutSalesReport = "WithoutSalesReport"
}
export enum trend {
    Positively = "Positively",
    Negative = "Negative",
    Neutral = "Neutral"
}

export interface IDataFilter  {
    IsGnvls?: boolean
    Expired?: IExpired
    LliquidLots?: ILliquidLots
    ExcessStock?: IExcessStock
    ActualPrice?: IActualPrice
    DashboardSalesReport?: ISalesReport
    DashboardWithoutSalesReport?: IWithoutSalesReport
    LifeLot?: number
    Sales?: number 
    PercentBestBefore?: number 
    IsExcessStock?: boolean 
    DifferencePercent?: number
    bestBeforeMonth?: number
}

export interface ILliquidLots  {
    LifeLot?: number
    Sales?: number
    StartDate?: DateTime
    EndDate?: DateTime
}

export interface IExcessStock  {
    IsExcessStock?: boolean
    StartDate?: DateTime
    EndDate?: DateTime
}

export interface IExpired  {
    BestBeforeMonth?: number
    PercentBestBefore?: number
    StartDate?: DateTime
    EndDate?: DateTime
    CompareBestBeforeMonth?: ICompareBestBeforeMonth
}

export interface ISalesReport  {
    IncludeCheques?: boolean
    IncludeMovements?: boolean
    IncludeInvoiceOut?: boolean
    LflPercentage?: number
    PeriodInDays?: number
    CompareSalesCount: IOption
}

export interface IWithoutSalesReport {
    PeriodInDays?: number
    CompareSalesCount?: ICompareSalesCount
}

export interface ICompareBestBeforeMonth  {
    Value?: string
    DisplayName?: string
}

export interface ICompareSalesCount  {
    Value?: string
    DisplayName?: string
}

export interface IActualPrice  {
    DifferencePercent?: number
}

export interface IJournalFilters {
    tabId: string;
    contractorId: string;
    contractorName: string;
    reportType: typeReport;
    filters: IDataFilter;
}

export interface UserCardFilterProps {
    onFilterChange?: (selectedContractors: string[]) => void;
    currentFilter: IGridFilter;
    data:IDashboardBusinessControlsViewDTO[] 
}
